import * as React from 'react';
import { classNames } from '@/utils';

export interface BlockCardProps {
  /** The child elements to be rendered within the BlockCard (required) */
  children: React.ReactNode;
  /** The title of the BlockCard (optional) */
  title?: React.ReactNode;
  /** The description of the BlockCard (optional) */
  description?: React.ReactNode;
  /** The action elements to be rendered at top right of the BlockCard (optional) */
  actions?: React.ReactNode;
  /** CSS class name(s) to be applied to the BlockCard root element (optional) */
  className?: string;
  /** The inline style object to be applied to the card element (optional) */
  style?: React.CSSProperties;
}

export const BlockCard = React.forwardRef<HTMLDivElement, BlockCardProps>((props, ref) => {
  const { title, description, children, actions, className, style } = props;

  return (
    <article ref={ref} className={classNames('card-block', className)} style={style}>
      {(title || description) && (
        <div className="title-wrapper">
          <div>
            {title && <h4>{title}</h4>}
            {description && <p className="text-secondary">{description}</p>}
          </div>
          {actions && <div className="items-group">{actions}</div>}
        </div>
      )}

      {children}
    </article>
  );
});

BlockCard.displayName = 'BlockCard';
